export default{ // 运行在 评估师APP-复检工单列表-检测报告
  tabs: [
    {
      name: 'editSellerInfo',
      path: '/editSellerInfo',
      component: () => import('./src/editSellerInfo'),
      meta: {
        title: '修改卖家信息'
      }
    }
  ]
}
